export const RequestErrorTip = '请求出错，请联系系统管理员'
export const DebounceDely = 200
